import { Component } from '@angular/core';

@Component({
  selector: 'app-hr',
  template: '',
  styleUrls: ['./hr.component.scss'],
})
export class HrComponent {}
